import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardComponent } from './card/card.component';
import { SelectcardComponent } from './selectcard/selectcard.component';



@NgModule({
  declarations: [
    CardComponent,
    SelectcardComponent
  ],
  imports: [
    CommonModule
  ]
})
export class PaymentModule { }
